import { createAction, createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  AcceptInvitationResponse,
  Credentials,
  LoginResponse,
  LoginResponseInterface,
  SignupInformation,
} from '../../models';
import { SsoLogin } from '../../models/sso-login.model';
import { AcceptInvitationRequest } from '../../models/accept-invitation-request.model';

export const loginActions = createActionGroup({
  source: 'Login to Account',
  events: {
    login: props<{ credentials: Credentials }>(),
    succeed: props<{ token: string }>(),
    failed: props<{ error: Error }>(),
  },
});

export const logoutActions = createActionGroup({
  source: 'Logout of Account',
  events: {
    logout: emptyProps(),
    succeed: props<{ redirectUrl: string }>(),
    authGuard: props<{ redirectUrl: string }>(),
    failed: props<{ error: Error }>(),
  },
});

export const userSessionActions = createActionGroup({
  source: 'Clear User Session',
  events: {
    clearSession: emptyProps(),
    clearSucceed: emptyProps(),
  },
});

export const registerActions = createActionGroup({
  source: 'Registration',
  events: {
    register: props<{ signupInformation: SignupInformation }>(),
    succeed: emptyProps(),
    failed: props<{ error: Error }>(),
  },
});

export const activateActions = createActionGroup({
  source: 'Activate Account',
  events: {
    activate: emptyProps(),
    succeed: emptyProps(),
    failed: props<{ error: Error }>(),
  },
});

export const resetPasswordActions = createActionGroup({
  source: 'Reset Password',
  events: {
    reset: props<{ password: string; confirmationCode: string }>(),
    succeed: emptyProps(),
    failed: props<{ error: Error }>(),
  },
});

export const changePasswordActions = createActionGroup({
  source: 'Change Password',
  events: {
    change: props<{ currentPassword: string; password: string }>(),
    force: emptyProps(),
    forcenavigate: emptyProps(),
    succeed: emptyProps(),
    failed: props<{ error: Error }>(),
  },
});

export const requestPasswordActions = createActionGroup({
  source: 'Request Password',
  events: {
    request: props<{ email: string }>(),
    succeed: emptyProps(),
    failed: props<{ error: Error }>(),
  },
});

export const localStorageActions = createActionGroup({
  source: 'Token Management',
  events: {
    'load token': emptyProps(),
    'load token succeed': props<{ token: string | null }>(),
  },
});

export const messageHandlingActions = createActionGroup({
  source: 'Message Handling',
  events: {
    'show success': emptyProps(),
    'hide success': props<{ message: string | null }>(),
    'hide error': emptyProps(),
  },
});

export const ssoActions = createActionGroup({
  source: 'Sso',
  events: {
    'load sso login': props<{ websiteId: number; websiteUrl: string }>(),
    'load sso login failed': props<{ error: Error }>(),
    'load sso login succeed': props<{ ssoLogin: SsoLogin }>(),
    'login with sso': props<{ authCode: string; websiteId: number }>(),
    'login with sso succeed': props<{ response: LoginResponse }>(),
    'login with sso failed': props<{ error: Error }>(),
    'go to identity provider': emptyProps(),
  },
});

export const invitationActions = createActionGroup({
  source: 'Invitation',
  events: {
    'validate invitation': props<{ invitation: string }>(),
    'validate invitation failed': props<{ error: Error }>(),
    'validate invitation succeed': props<AcceptInvitationResponse>(),
    'accept invitation': props<{ acceptInvitation: AcceptInvitationRequest }>(),
    'accept invitation failed': props<{ error: Error }>(),
    'accept invitation succeed': emptyProps(),
  },
});

export const impersonate = createAction('[Login Page] Impersonate');

export const validateWebsite = createAction('[User Settings] Validate WebsiteId');

export const saveTokenDetails = createAction(
  '[User Settings] Save Token Details',
  props<{ response: LoginResponseInterface }>(),
);

export const handleIncorrectPortal = createAction('[User Settings] Handle Incorrect Portal', props<{ email: string }>());

export const smsChallengeActions = createActionGroup({
  source: '[Login Page] Sms challenge',
  events: {
    request: props<{ credentials: Credentials; loginResponse: LoginResponse }>(),
    confirm: props<{ code: string | null }>(),
    succeed: props<{ loginResponse: LoginResponseInterface }>(),
    failed: props<{ error: Error }>(),
    reset: emptyProps(),
  },
});

export const setupMFAActions = createActionGroup({
  source: '[Login Page] Setup MFA',
  events: {
    request: props<{ credentials: Credentials; loginResponse: LoginResponse }>(),
    confirm: props<{ phoneNumber: string | null }>(),
    succeed: emptyProps(),
    failed: props<{ error: Error }>(),
  },
});

export const resendCodeActions = createActionGroup({
  source: '[Login Page] Resend code',
  events: {
    resend: emptyProps(),
    succeed: props<{ loginResponse: LoginResponse }>(),
    failed: props<{ error: Error }>(),
  },
});
